/** 线路排班-编辑模式 */
<template>
  <div id="schedulingFormEdit">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="platform" class="grid">
        <template slot="label"><i class="el-icon-time" style="margin-right:4px"></i>专线班次管理</template>
        <schedulingPlatformTimeFormEdit ref="schedulingPlatformTimeFormEdit" class="platform-left"
          :style="{ width: lineInfo.schedulingType == 2 ? '70%' : '100%', 'padding-right': lineInfo.schedulingType == 2 ? '20px' : '0' }"
          :lineId="lineId" @infoUpdate="infoUpdate" @dutyDriversUpdate="dutyDriversUpdate"
          @schedulingTimeUpdate="schedulingTimeUpdate" />
        <schedulingPlatformTimeDriverFormEdit class="platform-right" v-if="lineInfo.schedulingType == 2"
          :lineInfo="lineInfo" :dutyDrivers="dutyDrivers" @getDutyDriversDataByTime="getDutyDriversDataByTime"
          @isNewVehicleInfoUpdate="isNewVehicleInfoUpdate" />
      </el-tab-pane>
      <el-tab-pane name="driver" class="grid">
        <template slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>专线包车配置</template>
        <schedulingDriverTimeForm :lineId="lineId" /> 
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
export default {
  name: "schedulingFormEdit",
  components: {
    schedulingPlatformTimeFormEdit: () => import("./schedulingPlatformTimeFormEdit.vue"),
    schedulingPlatformTimeDriverFormEdit: () => import("./schedulingPlatformTimeDriverFormEdit.vue"),
    schedulingDriverTimeForm: () => import("./schedulingDriverTimeForm.vue"),
  },
  data() {
    return {
      tabAction: 'platform',
      lineId: this.$route.query.lineId,
      lineInfo: [],
      schedulingTime: null,
      dutyDrivers: [],
    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() { },
  methods: {
    infoUpdate(data) {
      this.lineInfo = data;
    },
    dutyDriversUpdate(data) {
      this.dutyDrivers = data;
    },
    schedulingTimeUpdate(data) {
      this.schedulingTime = data;
    },
    getDutyDriversDataByTime(schedulingTime) {
      this.$refs.schedulingPlatformTimeFormEdit.getDutyDriversDataByTime(schedulingTime);
    },
    isNewVehicleInfoUpdate(data) {
      this.$refs.schedulingPlatformTimeFormEdit.isNewVehicleInfoUpdate(data);
    }
  },
};
</script>

<style lang="less" scoped>
#schedulingFormEdit {
  width: 100%;

  div {
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
  }

  .platform-right {
    width: 30%
  }

  .el-tabs {
    width: 100%;
    .el-tab-pane{
      width: 100%;
    }
  }
}
</style>
